import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) { toast.success("Account created!"); nav("/"); }
    else toast.error(res.error);
  };

  return (
    <div className="container-deg py-20 md:py-28 max-w-md" data-testid="register-page">
      <div className="overline">{t("nav.register")}</div>
      <h1 className="font-serif text-4xl mt-3">{t("auth.register_title")}</h1>
      <p className="text-ink-soft mt-3">{t("auth.register_sub")}</p>
      <form onSubmit={submit} className="mt-10 space-y-6">
        <div>
          <label className="overline">{t("auth.name")}</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-deg mt-2" data-testid="register-name" />
        </div>
        <div>
          <label className="overline">{t("auth.email")}</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-deg mt-2" data-testid="register-email" />
        </div>
        <div>
          <label className="overline">{t("auth.password")}</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-deg mt-2" data-testid="register-password" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="register-submit">
          {loading ? t("common.loading") : t("auth.sign_up")}
        </button>
      </form>
      <p className="mt-8 text-sm text-ink-soft">
        {t("auth.have_account")} <Link to="/login" className="text-accent hover:underline" data-testid="register-login-link">{t("auth.sign_in")}</Link>
      </p>
    </div>
  );
}
